import React from 'react';


export default function Badge({ color, text }) {
  return (<span className={`badge ${color ? `color-${color}` : null}`}>{text}</span>);
}
